enum MediaQueries {
  Tablet = '@media only screen and (min-width: 768px)',
  LaptopSmall = '@media only screen and (min-width: 1200px)',
  LaptopLarge = '@media only screen and (min-width: 1440px)',
  Desktop = '@media only screen and (min-width: 1920px)'
}

export default MediaQueries
